module.exports = __webpack_public_path__ + "img/rm1chicun.63d16d69.png";